import LifeSaverIcon from './component.jsx'
export default LifeSaverIcon
